/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MaximizeIcon = /*#__PURE__*/ createSvgIcon(
  'MaximizeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.5 13.5h2.75c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 019.25 15h-3.5a.726.726 0 01-.534-.216A.726.726 0 015 14.25v-3.5c0-.213.071-.39.214-.534A.72.72 0 015.746 10c.21 0 .39.072.535.216a.72.72 0 01.219.534v2.75zm7-7h-2.75a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0110.75 5h3.5c.213 0 .39.072.534.216A.726.726 0 0115 5.75v3.5c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534V6.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MaximizeIcon;
